module.exports = __webpack_public_path__ + "img/O2O-pic1-02.718c5ba5.png";